<template>
<div class="registeremail">
		<el-container>
			<div class="main">
				<div class="pos_icon">
					<div class="icon"><img src="../../static/img/login2/registerPhone1.png" alt=""></div>
					<el-select slot="prepend" v-model="select" :placeholder="$t('login.areaCode')" class="change">
						<el-option v-for="(item,index) in cities" :key="index" :label="item.telShowCode" :value="item.telCode" class="list">
							<span style="float: left">{{ item.telShowCode}}</span>
							<span style="float: right; color: #8492a6; font-size: 13px">{{ item.language }}</span></el-option>
					</el-select>
				</div>
				
				<div class="pos_icon">
					<div class="icon"><img src="../../static/img/login2/registeremail1.png" alt=""></div>
					<el-input
						:placeholder="$t('forgetpassword.EnterEmail')"
						v-model="email"
						clearable
						class="mailbox"	
						maxlength="32"
				@change="emailVerification"		
						>
					</el-input>
				</div>
				<p class="danger" v-show="flag4">{{$t('forgetpassword.FalseEmail')}}</p>
				<p class="danger" v-show="flag7">{{$t('register.registeredemail')}}</p>
        		<p class="danger" v-show="flag11">{{$t('forgetpassword.NotEmail')}}</p>
				<div class="pos_icon">
					<div class="icon icon3"><img src="../../static/img/login2/registeremail2.png" alt=""></div>
					<el-input
						:placeholder="$t('register.enterPsd')"
						v-model="password"
						class="password"
						:type='emailPsw'
						@change="passwordVerification"
						maxlength="16"
					>
					</el-input>
					<div class="eye" @click="eye('emailPsw')"><img src="../../static/img/login2/registeremail3.png" alt=""></div>
				</div>
				<p class="danger" v-show="flag2">{{$t('changepassword.lessPsd')}}</p>
        		<p class="danger" v-show="flag10">{{$t('changepassword.notPsd')}}</p>
				<div class="pos_icon">
					<div class="icon icon3"><img src="../../static/img/login2/registeremail2.png" alt=""></div>
					<el-input
						:placeholder="$t('register.againEnterPsd')"
						v-model="repassword"
						class="password"
						:type='emailAgain'
						@input="repasswordVerification"
						maxlength="16"
					>
					</el-input>
					<div class="eye" @click="eye('emailAgain')"><img src="../../static/img/login2/registeremail3.png" alt=""></div>
				</div>
				<p class="danger" v-show="flag3">{{$t('changepassword.notSamePsd')}}</p>
  				<router-link to="/login" class="had"><p>{{$t('forgetpassword.HadAccount')}}</p></router-link>
				<el-button class="sub" @click="emailnext">{{$t('forgetpassword.submit')}}</el-button>
			</div>
		</el-container>
	</div>
</template>

<script>
import { Verification } from "../api/index.js";
import { registerSendEmail } from "../api/index.js";
import { userLogin } from "../api/index.js";
import { email } from "../api/index.js";
import { areaCode,emailRegister2 } from "../apiNew/index.js";
import store from "../store/store.js";
import Qs from "qs";
import axios from "axios";
export default{
	name:'registeremail',
	data(){
		return{
			flag4:false,//邮箱格式不正确
			flag7:false,//邮箱已被注册
			flag11:false,//邮箱未填
			flag2:false,//密码少于6位
			flag3:false,//密码不一致
			flag10:false,//密码未填
			email:'',
			password:'',
			repassword:'',
			select:'',
			emailPsw:'password',
			emailAgain:'password',
			value:'',
			cities: [{
						value: "+86",
						label: this.$t('countries.china')
					},
					{
						value: "+852",
						label: this.$t('countries.hongkong')
					},
					{
						value: "+853",
						label: this.$t('countries.macau')
					},
					{
						value: "+886",
						label: this.$t('countries.taiwan')
					},
					{
						value: "+001",
						label: this.$t('countries.America')
					},
					{
						value: "+49",
						label: this.$t('countries.Germany')
					},
					{
						value: "+81",
						label: this.$t('countries.Japan')
					}
					
				]
		}
	},
	mounted() {
		this.getareaCode()
		console.log(this.value)
  	},
  	methods: {
		//获取国家或地区区号
		getareaCode(){
			let params = Qs.stringify({
				lang: localStorage.getItem("locale")
			})
			areaCode(params)
			.then(res=>{
				console.log(res.data.data)
				this.cities = res.data.data
			})
			.catch(err=>{
				console.log("获取区号错误：",err)
			})
		},
  		emailVerification() {
			//flag4——邮箱格式不正确
			//flag7——邮箱已被注册
			//flag11——邮箱未填
			//flag2——密码少于6位
			//flag3——密码不一致
			//flag10——密码未填
	      	let reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
	      	if (reg.test(this.email)) {
	        	this.flag4 = false;
				this.flag11 = false;
				var params=Qs.stringify({
					account: this.email
				})
				email(params)
				.then(res=>{
					console.log("验证用户是否存在：[true:存在]",res)
					if(res.data.data==true){
						this.flag7=true;
					}else{
						this.flag7=false;
					}
				})
				.catch(error=>{
					console.log(error)
				})

	      	} else {
				if(this.email.length==0){
					this.flag4 = false;
					this.flag11=true;
					this.flag7 = false;
				}else{
					this.flag4 = true;
					this.flag11 = false;
					this.flag7 = false;
				}
	      	}
    	},
    	passwordVerification() {
			if(this.password.length < 6 && this.password.length > 0) {
				this.flag2 = true;
			} else {
				this.flag2 = false;
			}
			if(this.password.length == 0) {
				this.flag10 = true;
			} else {
				this.flag10 = false;
			}
			
		},
		repasswordVerification(){
			if(
				 this.repassword.length == 0  ||
				this.password != this.repassword
			) {
				this.flag3 = true;
			} else {
				this.flag3 = false;
			}
		},
		eye(type){
			switch (type){
				case 'emailPsw':
				if(this.emailPsw=='password'){
					this.emailPsw = 'text'
				}else{
					this.emailPsw = 'password'
				}
				break;
				case 'emailAgain':
				if(this.emailAgain=='password'){
					this.emailAgain = 'text'
				}else{
					this.emailAgain = 'password'
				}
				break;

			}
			
		},
		//邮箱注册
		emailnext(){
			
			if(
				 this.repassword.length == 0  ||
				this.password != this.repassword
			) {
				this.flag3 = true;
				return false;
			} else {
				this.flag3 = false;
			}
			
			// this.$store.commit("set_lang", localStorage.getItem("locale"));
			console.log(this.select)			

			let reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
			let params = Qs.stringify({
				areaCode:this.select,
				username:this.email,
				password:this.password
			})
			emailRegister2(params)
			.then(res=>{
				// console.log("邮箱注册：",res)
				if(res.data.header.status==1000){
					sessionStorage.setItem("login", "1");
					localStorage.setItem("token", res.data.data.accessToken);
					this.$store.commit("set_token", res.data.data.accessToken);
					console.log(localStorage.getItem("locale"))
					this.$router.push({path:'/mynewsedit'})
				}
				if(res.data.header.status==3045){
					this.$alert(this.$t('login.pswSimple'))
				}
			})
			.catch(err=>{
				console.log(err)
			})
	      	// if (reg.test(this.email)) {
			// 	var params=Qs.stringify({
			// 		account: this.email
			// 	})
			// 	email(params)
			// 	.then(res=>{
			// 		console.log("验证用户是否存在：[true:存在]",res)
			// 		if(res.data.data==true){
			// 			this.flag7=true;
			// 		}else{
			// 			if(this.password.length>5&&this.password==this.repassword){
			// 				this.flag7=false;
			// 				var params = Qs.stringify({
			// 					email: this.email,
			// 					password: this.password,
			// 					lang: ""
								
			// 				});
			// 				registerSendEmail(params)//注册发送激活邮件
			// 					.then(res => {
			// 					console.log("发送邮件：",res);
			// 					if (res.data.header.status == 1000 && res.data.data == null) {
			// 						this.$router.push({ path: "/emailproving",query:{
			// 							email:this.email,
			// 							password:this.password,
			// 							repassword:this.repassword
			// 						} });
			// 					}
			// 					if (res.data.header.status == 3026) {
			// 							this.$router.push({ path: "/emailproving",query:{
			// 							email:this.email,
			// 							password:this.password,
			// 							repassword:this.repassword
			// 						} });
			// 					}
			// 				})
			// 				.catch(error => {
			// 					console.log(error);
			// 				})
			// 			}else{
			// 				if(this.password.length==0){
			// 					this.flag10=true;
			// 				}
			// 				if(this.repassword!=this.password){
			// 					this.flag3=true;
			// 				}
			// 			}
			// 		}
			// 	})
			// 	.catch(error => {
			// 		console.log(error);
			// 	})
			// }else{
			// 	if(this.email.length==0){
			// 		this.flag11=true;
			// 	}
			// 	if(this.email.length!=0){
			// 		this.flag4=true;
			// 	}
			// }
			// if(this.password.length==0){
			// 	this.flag10=true;
			// }
			// if(this.repassword.length==0){
			// 	this.flag3=true;
			// }
		}
  	}
}
</script>
<style>
.registeremail .el-input input{
	border: 0;
	border-bottom: 1px solid #cccccc;
	border-radius: 0;
	box-sizing: border-box;
	padding-left: 2.5rem;
}
</style>
>
<style scoped>
	.registeremail{
		margin-top: 30px;
	}
	.main{
		width: 100%;
		padding: 0 20px;
	}
	.pos_icon{
		position: relative;
		width: 100%;
		height: 2.6rem;
		line-height: 2.6rem;
		margin-top: 20px;
	}
	.icon{
		position: absolute;
		z-index: 99;
		width: 2rem;
		height: 1.5rem;
		line-height: 1.5rem;
		border-right: 1px solid #cccccc;
		top: 0.5rem;
	}
	.icon img{
		width: 1rem;
		vertical-align: middle;
	}
	.eye{
		position: absolute;
		right: 0.5rem;
		top: 0.2rem;
	}
	.eye img{
		width: 1.2rem;
	}

	.change {
		width: 100%;
	}
	.sub{
		width: 72%;
		margin-left: 14%;
		font-size: 1rem;
		height: 2.6rem;
		line-height: 2.6rem;
		color: rgb(255,255,255);
		margin-top: 30px;
		border-radius: 1.3rem;
		background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
		border: 0;
		padding: 0 0;
	}
	.danger{
		font-size: 0.625rem;
		margin-top: 5px;
		color: red;
	}
	.list {
		width: 250px;
	}
	.had{
		display: block;
		width: 90%;
		margin: 0 auto;
		color: #7dc3f2;
		font-size: 0.5rem;
		text-align: right;
		margin-top: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/components/registeremail.vue